import { QRFC } from "./QRFC";
import { Globals } from "./Globals";

export class QUploadRFC extends QRFC {
  constructor() {
    super();
    this.fFileName = null;
    this.fDirectory = null;
  }

  InitUploadRFC(callbackObj, fileName, directory) {
    this.InitRemoteCall(callbackObj, "POST", false, false);
    this.SetAllowStacked(true);
    this.fFileName = fileName;
    this.fDirectory = directory;
  }

  GetCallName() {
    return "qupload";
  }

  DoTransactionComplete(response, callBackObj) {
    var r = response;
    var success = false;
    if (r == "success") success = true;

    callBackObj.UploadResult(success, this.fFileName, this.fDirectory);
  }

  DoTransactionFailed() {
    var wsMgr = Globals._wsMgr;
    var docMgr = wsMgr.GetDocMgr();
    if (docMgr?.fSaveInProgress) {
      docMgr.FinishAutoSave();
    }
  }
}
